import React from "react";
import "./Pages/PagesCss/PrivacyPolicy.css";

const ContentPolicy = () => {
  return (
    <div className="priv-container">
      <div className="priv-header">
        <h1 className="priv-title">Content Policy</h1>
        <p className="priv-update">Last updated: {new Date().toLocaleDateString()}</p>
      </div>

      <div className="priv-content">
        <div className="priv-intro">
          <p>
            At <strong>AfterTaxPay.net</strong>, we are committed to providing accurate and reliable content. This Content Policy explains the guidelines for content usage, contributions, and user behavior. AfterTaxPay.net is developed and maintained by <strong>D-Tech Studios</strong>.
          </p>
        </div>

        <div className="priv-section">
          <h2>1. Accuracy and Reliability</h2>
          <p>
            All content on AfterTaxPay.net, including articles, calculators, and tools, is intended for informational purposes only. While we strive for accuracy, we cannot guarantee that all information is complete or error-free. Users should verify any information before making decisions.
          </p>
          <ul>
            <li>Content is regularly reviewed and updated for accuracy</li>
            <li>Tax calculations are based on current laws and regulations</li>
            <li>Financial information reflects general principles, not specific advice</li>
            <li>Users should consult qualified professionals for personalized guidance</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>2. Content Ownership and Rights</h2>
          <p>
            All original content, including text, graphics, logos, calculators, and software, is the property of D-Tech Studios and protected by intellectual property laws.
          </p>
          <ul>
            <li>Content may not be reproduced without explicit permission</li>
            <li>Calculators and tools are provided for personal use only</li>
            <li>Commercial use of our content requires written authorization</li>
            <li>Proper attribution must be given when sharing our content</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>3. User Contributions</h2>
          <p>
            If users submit content, feedback, or suggestions, they grant AfterTaxPay.net and <strong>D-Tech Studios</strong> a non-exclusive, royalty-free, perpetual, and worldwide license to use, modify, and distribute that content. Users should not submit content that violates copyright, privacy, or other rights.
          </p>
          <ul>
            <li>User contributions must be original or properly licensed</li>
            <li>We reserve the right to moderate and remove user content</li>
            <li>Users retain ownership of their original contributions</li>
            <li>Submitted content may be used to improve our services</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>4. Prohibited Content</h2>
          <p>
            Users must not post or submit content that is:
          </p>
          <ul>
            <li>Illegal, defamatory, or fraudulent</li>
            <li>Offensive, abusive, or harmful to others</li>
            <li>Spam or promotional without authorization</li>
            <li>Infringing on intellectual property rights</li>
            <li>Misleading or containing false information</li>
            <li>Containing malicious code or viruses</li>
            <li>Violating privacy or data protection laws</li>
            <li>Promoting illegal activities or harmful conduct</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>5. Content Moderation</h2>
          <p>
            We reserve the right to review, moderate, and remove any content that violates this policy or our Terms of Service.
          </p>
          <ul>
            <li>Content may be removed without prior notice</li>
            <li>Repeat violations may result in account suspension</li>
            <li>We are not obligated to monitor all user content</li>
            <li>Users can report inappropriate content for review</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>6. External Links and References</h2>
          <p>
            AfterTaxPay.net may include links to third-party websites. We are not responsible for the content, accuracy, or practices of these external sites.
          </p>
          <ul>
            <li>External links are provided for additional information only</li>
            <li>We do not endorse or guarantee third-party content</li>
            <li>External sites have their own terms and privacy policies</li>
            <li>Users access external content at their own risk</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>7. Content Updates and Changes</h2>
          <p>
            We may update, modify, or remove content at any time without notice. Users are encouraged to check back regularly to stay informed of changes.
          </p>
          <ul>
            <li>Tax content is updated to reflect law changes</li>
            <li>Calculators may be modified for accuracy improvements</li>
            <li>Articles may be revised for clarity or completeness</li>
            <li>We are not obligated to maintain specific content indefinitely</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>8. Content Licensing</h2>
          <p>
            Certain content may be available under specific licenses. Users must comply with the terms of any applicable licenses.
          </p>
          <ul>
            <li>Open source components follow their respective licenses</li>
            <li>Third-party content is used with proper permissions</li>
            <li>License information is available upon request</li>
            <li>Commercial licensing options may be available</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>9. User Responsibilities</h2>
          <p>
            Users are responsible for their interactions with our content and services.
          </p>
          <ul>
            <li>Use content in accordance with this policy</li>
            <li>Respect intellectual property rights</li>
            <li>Report content errors or concerns promptly</li>
            <li>Use calculators and tools for their intended purposes</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>10. Policy Enforcement</h2>
          <p>
            We take violations of this Content Policy seriously and may take appropriate action, including content removal and account termination.
          </p>
          <ul>
            <li>Violations are investigated promptly</li>
            <li>Users will be notified of policy violations when appropriate</li>
            <li>Appeals may be submitted for review</li>
            <li>Legal action may be taken for serious violations</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>11. Policy Changes</h2>
          <p>
            We may update this Content Policy to reflect changes in our practices or legal requirements.
          </p>
          <ul>
            <li>Changes will be posted on this page</li>
            <li>Continued use constitutes acceptance of changes</li>
            <li>Major changes may be announced separately</li>
            <li>Users should review this policy periodically</li>
          </ul>
        </div>

        <div className="priv-section">
          <h2>12. Contact Us</h2>
          <p>
            For questions regarding this Content Policy, please contact us at <strong>support@aftertaxpay.net</strong>.
          </p>
          <p>
            For content-related inquiries, including permissions and licensing, please include "Content Policy" in your subject line for faster response.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContentPolicy;